import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LoyaltyPrograms } from '@models/index';
import { TranslateService } from '@ngx-translate/core';
import { languagesPipe } from '@utils/constants/languagesPipe'
import moment from "moment/moment";
@Pipe({
    name: 'loyaltyPrograms',
    standalone: false
})
export class LoyaltyProgramsPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    const program = LoyaltyPrograms.findByid(value);
    return program ? program.name : '';
  }

  searchLoyaltyProgram() {
  }

}

@Pipe({
    name: 'AMPM',
    standalone: false
})
export class AMPMPipe implements PipeTransform {
  transform(value: string): string {
    if(value){
      return Number(value?.substring(0,2)) > 11 ?  `${value} PM`: `${value} AM`;
    }else{
      return value
    }
  }
}

@Pipe({
    name: 'localizedDate',
    pure: false,
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: Date | string, format = 'mediumDate'): string {
    const validLang = this.translateService.currentLang == 'du-NL' ? 'en-US' : this.translateService.currentLang;
    const lang = languagesPipe[validLang];
    const datePipe = new DatePipe( lang );
    
    if (!moment(value).isValid()) {
      return lang == 'es-MX' ? 'Fecha inválida' : 'N/A';
    }

    return value? datePipe.transform(value, format).toUpperCase() : 'N/A';
  }
}


@Pipe({
    name: 'HourTo24FromAMPM',
    pure: false,
    standalone: false
})
export class HourTo24FromAMPMDatePipe implements PipeTransform {
  constructor() {}

  transform(value: string, apply = true): string {
    let dateFormat = 'N/A';
    const date = moment(value, ["h:mm A"]);
    if (date.isValid())
      if(value  && apply) {
        dateFormat = date.format("HH:mm");
      }
      else {
        if (!apply && value)
          dateFormat = value;
      }
    return dateFormat;
  }
}

@Pipe({
    name: 'seatubication',
    pure: false,
    standalone: false
})
export class SeatUbicationPipe implements PipeTransform {
  constructor(private  translateService: TranslateService) {}

  transform(value: SeatTypes ): string {
    let text = "";
    switch (value) {
      case "A":
        text = `seatReview.aisle`;
        break;
      case "M":
        text = `seatReview.middle`;
        break;
      case "W":
        text = `seatReview.window`;
        break
      default:
        break
    }
    return text? this.translateService.instant(text): '';
  }
}

type SeatTypes = "A" | "W" | "M" | null | ''

@Pipe({
    name: 'maskProtectNumber',
    standalone: false
})
export class MaskProtectNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    const lastDigits = value.slice(-4);

    return `**** ${ lastDigits }`;
  }
}